import { render, staticRenderFns } from "./PotensiDesa.vue?vue&type=template&id=482156b4&scoped=true"
import script from "./PotensiDesa.vue?vue&type=script&lang=js"
export * from "./PotensiDesa.vue?vue&type=script&lang=js"
import style0 from "./PotensiDesa.vue?vue&type=style&index=0&id=482156b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482156b4",
  null
  
)

export default component.exports